import { render, staticRenderFns } from "./zip.vue?vue&type=template&id=463ac8eb&"
import script from "./zip.vue?vue&type=script&lang=js&"
export * from "./zip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports